/**
 * The one key space for muses (plan `2026_10_09_ovid_own_muse.md` § Design 1). The chosen muse
 * (`User.ovidMuseSlug`), `PackGrant.museSlug` and a wall row's `museSlug` all hold a muse KEY: a
 * roster slug (`ines`), or an own-muse key (`own:<userModelId>`).
 *
 * Roster slugs are lowercase ASCII words and never carry a colon, so an own key cannot collide with
 * one. Client-safe (no server imports): the strip and the chooser compare keys in the browser.
 */
export const OWN_MUSE_PREFIX = 'own:'

export function ownMuseKey(userModelId: string): string {
    return `${OWN_MUSE_PREFIX}${userModelId}`
}

/** The model id behind an own-muse key, or null for anything else (a roster slug, junk). */
export function parseOwnMuseKey(key: string): string | null {
    if (!key.startsWith(OWN_MUSE_PREFIX)) return null
    const id = key.slice(OWN_MUSE_PREFIX.length)
    return id.length > 0 ? id : null
}

/** The longest name an owner gives her own muse. */
export const OWN_MUSE_NAME_MAX = 40
